import React from "react";

import { InfoOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";

import Tooltip_ from "root/components/Tooltip";

// ---------------------------------------------------------------------------------------------------------------------
export default function ExternalDataAccurancy({ dataCorrectLevel }) {
  if (!dataCorrectLevel.text) return null;
  return (
    <Tooltip_
      title={
        <Box sx={{ textAlign: "start" }}>
          В зависимости от качества сырых данных об остатках мы разделяем уровень точности расчетов
          на 3 группы: <br />
          <ul>
            <li>Высокая достоверность</li>
            <li>Заказы могут быть немного занижены</li>
            <li>Точность заказов не определена</li>
          </ul>
        </Box>
      }>
      <Box
        sx={{
          border: "1px solid black",
          borderRadius: "0.5rem",
          padding: "0.25rem",
          borderColor: dataCorrectLevel.borderColor,
          color: dataCorrectLevel.color,
        }}
        display={"flex"}
        gap={1}
        width={"max-content"}
        height={"max-content"}>
        <InfoOutlined />
        {dataCorrectLevel.text}
      </Box>
    </Tooltip_>
  );
}

// ---------------------------------------------------------------------------------------------------------------------
export const getExternalDataAccurancyLevel = ({
  percent_sales,
  sales_percent,
  diff_sales,
  orders,
  onlyProductCard,
  ordersLessThenReviews,
} = {}) => {
  // Если отзывов больше чем выкупов то мы считаем эти данные некорректными, иначе смотрим по продавцу
  if (ordersLessThenReviews) return low;
  if (onlyProductCard) return high;
  const preparePercent = (percent_sales || sales_percent) / 100;
  const percent = preparePercent > 1 ? 0.98 : preparePercent;
  const calcOrders = diff_sales / percent;
  const diffPercent = calcOrders - orders;
  // Доработка от Владлена, если у поставщика заказы по Церебро = 0 значит недостоверно
  // if (!diff_sales || !percent) return low;

  if (diffPercent / calcOrders <= 0.25) return high;

  if (diffPercent / calcOrders > 0.25 && diffPercent / calcOrders <= 0.5) return medium;

  if (0.5 >= diffPercent / calcOrders) return low;

  return low;
};

const high = {
  id: "high",
  text: "Высокая достоверность заказов по остаткам",
  color: "#1F7A1F",
  borderColor: "#A1E8A1",
  isCorrect: true,
};

const medium = {
  id: "medium",
  text: "Заказы по остаткам могут быть немного занижены",
  color: "#9A5B13",
  borderColor: "F3C896",
};

const low = {
  id: "low",
  text: "Точность заказов не определена",
  color: "#32383E",
  borderColor: "#32383E",
};
